<template>
  <div class="xpsy-index">
    <van-tabs v-model:active="active" title-active-color="#007AFF">
      <van-tab title="专业评测">
        <div
          class="box"
          @click="startTExt(item.testName, item.oneLevelId)"
          v-for="item in zyceshi"
          :key="item.id"
        >
          <div class="one">
            <div class="one_one">
              <p>{{ item.testName }}</p>
              <p>测评预计：{{ item.testTime }}</p>
            </div>
            <div class="two">
              <div class="twotwo">
                <img :src="item.url" alt="" />
              </div>
            </div>
            <div class="three">
              <div class="three-item">
                {{ item.remark }}
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="趣味评测">
        <div
          class="box"
          @click="startTExt(item.testName, item.oneLevelId)"
          v-for="item in zyceshit"
          :key="item.id"
        >
          <div class="one">
            <div class="one_one">
              <p>{{ item.testName }}</p>
              <p>测评预计：{{ item.testTime }}</p>
            </div>
            <div class="two">
              <div class="twotwo">
                <img :src="item.url" alt="" />
              </div>
            </div>
            <div class="three">
              <div class="three-item">
                {{ item.remark }}
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { ceList } from "../../api/user";
export default {
  data() {
    return {
      active: 0,
      zhuangye: {
        type: 1,
      },
      zhuangyerig: {
        type: 2,
      },
      zyceshi: [],
      zyceshit: [],
    };
  },
  created() {
    this.getce();
    this.fastpink();
  },
  methods: {
    startTExt(name, id) {
      if (name == "匹兹堡睡眠质量指数") {
        this.miniJump(`/sleep?id=${id}`)
      } else {
        this.miniJump(`/detection?id=${id}`)
      }
    },
    async fastpink() {
      const res = await ceList(this.zhuangyerig);
      this.zyceshit = res.rows;
    },

    async getce() {
      const res = await ceList(this.zhuangye);
      this.zyceshi = res.rows;
    },
    gohomes() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.xpsy-index {
  .box {
    width: 100%;
    background: #f7f7f7;
    padding: 0.625rem 3% 0;
    .one {
      width: 100%;
      background: #fefffe;
      border-radius: 8px;
      padding-bottom: 10px;
      .three {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
        .three-item {
          width: 90%;
          padding: 10px;
          box-sizing: border-box;
          height: 90%;
          background: #f7f7f7;
          color: #666666;
          font-size: 0.9rem;
          border-radius: 8px;
          display: flex;
          align-items: center;
        }
      }
      .two {
        width: 100%;
        height: 160px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .twotwo {
          width: 90%;
          height: 160px;
        }
        img {
          border-radius: 10px;

          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .one_one {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        box-sizing: border-box;
        p:first-child {
          color: #323332;
          font-size: 1rem;
          font-weight: 600;
        }
        p:last-child {
          color: #999999;
          font-size: 0.9rem;
        }
      }
    }
  }
  ::v-deep .van-tabs__line {
    background-color: #007aff;
  }
}
</style>